import { Row, Col, Input } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { useIndexedDBStore } from "use-indexeddb";
import moment from "moment";
import {
  getDayNameAndDay,
  getMuiTheme,
  getTranslatedValue,
} from "../../utils/Utils";
import { DataGrid } from "@mui/x-data-grid";
import { toGetListOfAssessmentUser } from "../../utils/APIs";
import { ThemeProvider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ScreenLoader from "../../components/ScreenLoader";

const History = () => {
  const navigate = useNavigate();

  const { getAll, deleteAll, add } = useIndexedDBStore("assessments");
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [initialList, setInitialList] = useState([]);

  // const options = {
  //   filter: true,
  //   filterType: "dropdown",
  //   print: false,
  //   download: false,
  //   selectableRows: false,
  //   textLabels: {
  //     filter: {
  //       all: getTranslatedValue("all"),
  //       title: "",
  //       reset: getTranslatedValue("reset"),
  //     },
  //     body: {
  //       noMatch: getTranslatedValue("noMatch"),
  //       toolTip: getTranslatedValue("sort"),
  //     },
  //     pagination: {
  //       next: getTranslatedValue("nextPage"),
  //       previous: getTranslatedValue("previousPage"),
  //       rowsPerPage: getTranslatedValue("rowsPerPage"),
  //       displayRows: getTranslatedValue("of"),
  //     },
  //     toolbar: {
  //       search: getTranslatedValue("search"),
  //       viewColumns: getTranslatedValue("viewColumns"),
  //       filterTable: getTranslatedValue("filterTable"),
  //     },
  //   },
  // };

  // const columns = [
  //   {
  //     label: getTranslatedValue("clinicName"),
  //     name: "clinicName",
  //     options: {
  //       filter: true,
  //       sort: true,
  //     },
  //   },
  //   {
  //     label: getTranslatedValue("doctorName"),
  //     name: "doctorName",
  //     options: {
  //       filter: true,
  //       sort: true,
  //     },
  //   },

  //   {
  //     label: getTranslatedValue("dateGenerationNoBR"),
  //     name: "dt__created",
  //     options: {
  //       filter: true,
  //       sort: true,
  //       customBodyRender: (value, tableMeta, updateValue) => (
  //         <span>{value != null ? getDayNameAndDay(value) : ""}</span>
  //       ),
  //     },
  //   },
  //   {
  //     label: getTranslatedValue("backup"),
  //     name: "status",

  //     options: {
  //       customBodyRender: (value, tableMeta, updateValue) => (
  //         <div span={4}>
  //           <img
  //             src={
  //               value == 1
  //                 ? "/images/icons/success.svg"
  //                 : "/images/icons/hourglass.svg"
  //             }
  //             style={{ width: "3vh" }}
  //           />
  //         </div>
  //       ),
  //     },
  //   },
  //   {
  //     label: getTranslatedValue("edit"),
  //     name: "",

  //     options: {
  //       filter: false,
  //       sort: false,
  //       viewColumns: false,

  //       customBodyRender: (value, tableMeta, updateValue) => (
  //         <div
  //           span={4}
  //           style={{
  //             margin: "auto",
  //             alignItems: "center",
  //           }}
  //         >
  //           <img
  //             style={{ width: "4vh" }}
  //             src="/images/icons/edit.svg"
  //             className="roi--cursor"
  //             onClick={() =>
  //               navigate("/tool", {
  //                 state: {
  //                   id: tableMeta.currentTableData[tableMeta.rowIndex].data[
  //                     tableMeta.currentTableData[tableMeta.rowIndex].data
  //                       .length - 1
  //                   ],
  //                 },
  //               })
  //             }
  //           />
  //         </div>
  //       ),
  //     },
  //   },
  //   {
  //     label: "",
  //     name: "",

  //     options: {
  //       viewColumns: false,

  //       customBodyRender: (value, tableMeta, updateValue) => (
  //         <div
  //           span={4}
  //           style={{
  //             margin: "auto",
  //             textAlign: "right",
  //             alignItems: "center",
  //           }}
  //           onClick={() =>
  //             navigate("/results", {
  //               state: {
  //                 id: tableMeta.currentTableData[tableMeta.rowIndex].data[
  //                   tableMeta.currentTableData[tableMeta.rowIndex].data.length -
  //                     1
  //                 ],
  //               },
  //             })
  //           }
  //         >
  //           <img
  //             style={{ width: "1.5vh" }}
  //             src="/images/icons/next.svg"
  //             className="roi--cursor"
  //           />
  //         </div>
  //       ),
  //     },
  //   },
  //   {
  //     label: "",
  //     name: "id",
  //     options: {
  //       filter: false,
  //       viewColumns: false,

  //       sort: false,
  //       display: false,
  //     },
  //   },
  // ];

  const columns = [
    {
      field: "clinicName",
      headerName: getTranslatedValue("clinicName"),
      flex: 1,
      filterable: true,
    },
    {
      field: "doctorName",
      headerName: getTranslatedValue("doctorName"),
      flex: 1,
      filterable: true,
    },
    {
      field: "dt__created",
      headerName: getTranslatedValue("dateGenerationNoBR"),
      flex: 1,
      renderCell: (params) => (
        <span>{params.value ? getDayNameAndDay(params.value) : ""}</span>
      ),
    },

    {
      field: "edit",
      headerName: getTranslatedValue("edit"),
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <img
          style={{ width: "4vh" }}
          src="/images/icons/edit.svg"
          className="roi--cursor"
          onClick={() =>
            navigate("/tool", {
              state: { id: params.row.id },
            })
          }
          alt="edit"
        />
      ),
    },
    {
      field: "view",
      headerName: "",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{
            margin: "auto",
            textAlign: "right",
            alignItems: "center",
          }}
          onClick={() =>
            navigate("/results", {
              state: { id: params.row.id },
            })
          }
        >
          <img
            style={{ width: "1.5vh" }}
            src="/images/icons/next.svg"
            className="roi--cursor"
            alt="next"
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    toGetListOfAssessmentUser()
      .then((res) => {
        deleteAll().then(() => {
          res.forEach((element) => {
            add(element);
          });
          getList();
        });
      })
      .catch((e) => {
        getList();
      });
  }, []);

  const getList = () => {
    getAll().then((res) => {
      var x = res.filter((el) => el.doctorName != "");
      var l__res = x.filter((el) => el.status == 0 || el.status == 1);
      l__res.reverse();
      setList(l__res);
      setLoading(false);
      setInitialList(res);
    });
  };

  return (
    <>
      {loading && <ScreenLoader />}
      <HeaderUser />
      <div style={{ marginTop: "2vh" }}>
        <Row>
          <Col
            span={24}
            className="roi--settings-title"
            style={{ marginTop: "1.5vh", textAlign: "center" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="history" />
            </span>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "5vh" }}>
        <ThemeProvider theme={getMuiTheme()}>
          <DataGrid
            rows={list}
            columns={columns}
            disableColumnFilter={false}
            disableColumnMenu={false}
            disableSelectionOnClick
            checkboxSelection={false}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                color: "#54596E !important",
                fontSize: "20px !important",
                lineHeight: "20px !important",
                fontStyle: "normal !important",
                textTransform: "uppercase",
                fontFamily: "Gotham",
                textAlign: "center",
              },
              "& .MuiDataGrid-cell": {
                backgroundColor: "#F5F8FA",
                color: "#54596E",
                fontSize: "20px",
                lineHeight: "20px",
                fontStyle: "normal",
                fontWeight: "normal",
                fontFamily: "Gotham",
                textAlign: "center",
              },
            }}
          />
        </ThemeProvider>
      </div>
      {/* <Row style={{ marginTop: "4vh" }}>
        <Col span="2"></Col>
        <Col span="20">
          <Input
            prefix={<SearchOutlined />}
            placeholder={getTranslatedValue("search")}
            onInput={(e) => search(e)}
          />
        </Col>
        <Col span="2"></Col>
      </Row>
      <Row style={{ marginTop: "4vh" }}>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage
              id="clinicNameSettings"
              values={{ roi__br: <br /> }}
            />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage
              id="doctorNameSettings"
              values={{ roi__br: <br /> }}
            />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage
              id="dateGeneration"
              values={{ roi__br: <br /> }}
            />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage id="backup" values={{ roi__br: <br /> }} />
          </span>
        </Col>
        <Col span="4"></Col>
      </Row>
      <div
        style={{
          textAlign: "center",
          maxHeight: "65vh",
          overflowY: "auto",
        }}
      >
        {list.map((el) => (
          <Row
            style={{ marginTop: "2vh" }}
            className="roi--background-section roi--cursor"
            onClick={() =>
              navigate({
                pathname: "/results",
                state: { id: el.id },
              })
            }
          >
            <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
              <span className="roi--history-clinic-name ">{el.clinicName}</span>
            </Col>
            <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
              <span className="roi--history-clinic-name ">{el.doctorName}</span>
            </Col>
            <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
              <span className="roi--history-date">{el.dateCreation}</span>
            </Col>
            <Col span="5" style={{ textAlign: "center", marginTop: "1vh" }}>
              <img
                src={
                  el.status == 1
                    ? "/images/icons/success.svg"
                    : "/images/icons/hourglass.svg"
                }
                style={{ width: "3vh" }}
              />
            </Col>
            <Col
              span={4}
              style={{
                margin: "auto",
                padding: "10px",
                textAlign: "right",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "1.5vh" }}
                src="/images/icons/next.svg"
                className="roi--cursor"
              />
            </Col>{" "}
          </Row>
        ))}
      </div>
      <Row style={{ marginTop: "2vh" }}></Row> */}
    </>
  );
};
export default History;
